module.exports = __webpack_public_path__ + "assets/img/8702f3a7b7ae72c40042d9f500337eee.png";